import { selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";
import { shallowEqual } from "../../../utils/shallowEqual";
import type { AddressSyncConfig } from "../types";

/**
 * Atom that selects address sync config from the questionnaire state.
 *
 * This config determines which questions trigger address syncing and
 * what field mappings to use. When undefined, defaults are used.
 */
export const questionnaireAddressSyncConfigAtom = selectAtom(
  questionnaireReducerAtom,
  (state): AddressSyncConfig | undefined =>
    state.config?.addressSync as AddressSyncConfig | undefined,
  (a, b) => {
    if (a === undefined && b === undefined) return true;
    if (a === undefined || b === undefined) return false;
    return shallowEqual(a, b);
  },
);
